import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import * as configuratorActions from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';
import { withGlobalLoader } from '@configuratorware/configurator-frontendgui/App/Reducers/UI/Actions';
import ConfigurationToolbar from '../Components/ConfigurationToolbar/ConfigurationToolbar';
import { useDispatch } from 'react-redux';
import ScreenLayout from '../Components/ScreenLayout';
import { Visualization } from '../Components/Visualization';
import ThemeProvider from './ThemeProvider';
import { Footer } from '../Components/Footer';
import RequestOffer from '../Components/RequestOffer';
import HowToConfigureHint from '../Components/HowToConfigureHint/HowToConfigureHint';
import ContainerDialog from '../Components/ContainerDialog';
import FloorSelection from '../Components/FloorSelection';
import { ScreenshotProvider } from '../Components/ScreenshotContext';

const useStyles = makeStyles((theme) => ({
  bottomContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  ctaContainer: {
    display: 'flex',
    gap: 16,
    alignSelf: 'center',
    justifyContent: 'end',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      padding: '5px 10px',
    },
  },
  floorSelectionContainer: {
    position: 'absolute',
    display: 'flex',
    top: '85px',
    right: '15px',
  },
}));

export const ConfiguratorScreen = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      const configuration = (
        await dispatch(withGlobalLoader(configuratorActions.fetchInitialConfiguration()))
      ).data;
      dispatch(withGlobalLoader(configuratorActions.loadInitialOptionclassification(configuration)));
    })();
  }, [dispatch]);

  return (
    <ThemeProvider>
      <ScreenshotProvider>
        <ScreenLayout fullWidth>
          <Visualization />
          <ConfigurationToolbar />
          <ContainerDialog />
          <div className={classes.bottomContainer}>
            <div className={classes.ctaContainer}>
              <RequestOffer />
            </div>
          </div>
          <div className={classes.floorSelectionContainer}>
            <FloorSelection />
          </div>
          <HowToConfigureHint />
          <Footer />
        </ScreenLayout>
      </ScreenshotProvider>
    </ThemeProvider>
  );
};

ConfiguratorScreen.propTypes = {};

ConfiguratorScreen.defaultProps = {};

export default ConfiguratorScreen;
